import { AmplifySignOut } from "@aws-amplify/ui-react";

function Unauthorized() {
    return (
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
            <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <h1 className="text-2xl font-semibold text-gray-900">Unauthorized!</h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                    <h1>In order to access this site, you must be:</h1>
                    <ul>
                        <li>Agent</li>
                        <li>Administrator</li>
                    </ul>
                    <AmplifySignOut />
                </div>
            </div>
        </main>
    );
}
export default Unauthorized;
